import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import type { SafetyCaseRecord } from '../../services/reportsApi';
import {
  latestSignedSafetyScanLabel,
  newActivityStateLabel,
  safetyCaseCardTitle,
} from '../../domain/safetyCases/safetyCaseWorklist';

type Props = {
  open: boolean;
  cases: SafetyCaseRecord[];
  onClose: () => void;
  onSelect: (item: SafetyCaseRecord) => void;
};

export default function SafetyCaseLinkDisambiguationDialog({
  open,
  cases,
  onClose,
  onSelect,
}: Props) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" data-testid="safety-case-link-disambiguation">
      <DialogTitle>Select Safety Case</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={1.5}>
          {cases.map((item) => (
            <Stack
              key={String(item.safety_case_id || item.finding_id || item.workflow_id)}
              spacing={0.5}
              sx={{ border: '1px solid #E5E7EB', borderRadius: 2, p: 1.5 }}
            >
              <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                {safetyCaseCardTitle(item)}
              </Typography>
              <Typography variant="body2">{`Latest Signed Safety Scan: ${latestSignedSafetyScanLabel(item)}`}</Typography>
              <Typography variant="body2">{newActivityStateLabel(item)}</Typography>
              <Button variant="outlined" size="small" sx={{ alignSelf: 'flex-start' }} onClick={() => onSelect(item)}>
                Link this Safety Case
              </Button>
            </Stack>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
